import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import {
    ROUTE_APP_CARD_PAYMENT_CONFIRMATION,
    ROUTE_APP_EMPTY,
    ROUTE_APP_QUOTATION,
    ROUTE_APP_SUMMARY,
} from "../../constants/routes/app";
import { ChannelProvider } from "../../libs/channels/components/channel-provider";
import store from "../../redux/store";
import GenericErrorModal from "../generic-error-modal/generic-error-modal";
import routes from "./app.routes";
import "./app.scss";
import { RoutesContainer } from "./components/routes-container";
import { ChannelHandler } from "./components/channel-handler";

const allRoutes = [
    ROUTE_APP_EMPTY,
    ROUTE_APP_QUOTATION,
    ROUTE_APP_SUMMARY,
    ROUTE_APP_CARD_PAYMENT_CONFIRMATION,
];

const App: React.FC = () => {
    return (
        <Provider store={store}>
            <div className="app" data-testid="app">
                <Router basename={process.env.PUBLIC_URL}>
                    <ChannelProvider allRoutes={allRoutes}>
                        <RoutesContainer>
                            {routes}
                            <ChannelHandler />
                            <GenericErrorModal />
                        </RoutesContainer>
                    </ChannelProvider>
                </Router>
            </div>
        </Provider>
    );
};

export default App;
